import React from 'react';
import { PieChart, Users, Calculator } from 'lucide-react';

/**
 * Секция для учета доходов и расходов в виде дивидендов
 */
const DividendsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PieChart className="w-5 h-5 mr-2 text-amber-500" />
        Дивиденды
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Доходы в виде дивидендов */}
        <div>
          <label htmlFor="dividendsIncome" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calculator className="w-4 h-4 mr-1 text-amber-500" />
            Доходы в виде дивидендов
          </label>
          <input
            type="text"
            id="dividendsIncome"
            name="dividendsIncome"
            value={formData.dividendsIncome}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.dividendsIncome ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.dividendsIncome && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.dividendsIncome}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Сумма дивидендов, полученных организацией
          </p>
        </div>

        {/* Расходы на выплату дивидендов */}
        <div>
          <label htmlFor="dividendsExpenses" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Calculator className="w-4 h-4 mr-1 text-amber-500" />
            Расходы на выплату дивидендов
          </label>
          <input
            type="text"
            id="dividendsExpenses"
            name="dividendsExpenses"
            value={formData.dividendsExpenses}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.dividendsExpenses ? 'input-error' : ''}`}
            placeholder="Введите сумму"
          />
          {errors.dividendsExpenses && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.dividendsExpenses}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Сумма дивидендов, выплаченных организацией
          </p>
        </div>

        {/* Тип получателя дивидендов */}
        <div>
          <label htmlFor="participantType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-1 text-amber-500" />
            Тип получателя дивидендов
          </label>
          <select
            id="participantType"
            name="participantType"
            value={formData.participantType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="resident">Российская организация</option>
            <option value="non-resident">Иностранная организация</option>
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            От типа получателя зависит применяемая ставка налога
          </p>
        </div>

        {/* Доля участия в капитале */}
        <div>
          <label htmlFor="participationShare" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <PieChart className="w-4 h-4 mr-1 text-amber-500" />
            Доля участия в капитале (%)
          </label>
          <input
            type="text"
            id="participationShare"
            name="participationShare"
            value={formData.participationShare}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.participationShare ? 'input-error' : ''}`}
            placeholder="Введите процент"
          />
          {errors.participationShare && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.participationShare}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Для организаций с долей участия более 50% и вкладом от 5 млн руб. действует ставка 0%
          </p>
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-amber-100 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 dark:border-amber-800">
        <div className="flex items-start">
          <PieChart className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
              О налогообложении дивидендов
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              Налогообложение дивидендов регулируется ст. 284 НК РФ. Для российских организаций ставка налога составляет 13%. При выплате дивидендов иностранным организациям применяется ставка 15% (если иное не предусмотрено международными договорами). Для организаций с долей участия более 50% и сроком владения более 365 дней, при условии, что размер вклада превышает 5 млн руб., применяется ставка 0% (пп. 1 п. 3 ст. 284 НК РФ).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DividendsSection;